// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GiftCards-page-Marvp {
  --red: #e8232b;
  --red-d: #c2151c;
  --green: #16a34a;
  --green-d: #0f7a37;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.GiftCards-wrap-Mdtog {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

.GiftCards-sec-nwBTl {
  padding: 56px 0;
}

.GiftCards-alt-oJqwn {
  background: #f7f8f9;
}

.GiftCards-h2-OxCId {
  font-size: clamp(26px, 4vw, 36px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 28px;
}

.GiftCards-h2Left-fgxKE {
  font-size: clamp(22px, 3.4vw, 30px);
  font-weight: 800;
  margin: 0 0 8px;
}

/* Coming-soon banner */

.GiftCards-soonSec-XaQLh {
  padding: 36px 0 8px;
  text-align: center;
}

.GiftCards-soonBadge-N8Hwm {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  background: #fff0ef;
  color: var(--red);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid #f6c9cb;
}

.GiftCards-soonDot-M6c60 {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--red);
}

.GiftCards-soonText-nukZ6 {
  max-width: 620px;
  margin: 18px auto 0;
  font-size: 16px;
  line-height: 1.6;
  color: var(--muted);
}

/* Pitch cards */

.GiftCards-grid-TpFD_ {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.GiftCards-card-N3nW9 {
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 28px 24px;
  background: #fff;
  text-align: center;
}

.GiftCards-cardIc-RTKMY {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: #fff0ef;
  color: var(--red);
  margin-bottom: 14px;
}

.GiftCards-cardIc-RTKMY svg {
  width: 28px;
  height: 28px;
}

.GiftCards-cardTitle-HNi4K {
  font-size: 17px;
  font-weight: 800;
  margin: 0 0 8px;
}

.GiftCards-cardText-BFGEr {
  font-size: 14px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0;
}

/* Notify card */

.GiftCards-notifyCard-pCAz2 {
  max-width: 620px;
  margin: 0 auto;
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 34px 36px;
  background: #e4f6f3;
  text-align: center;
}

.GiftCards-notifyText-dyxvg {
  font-size: 15px;
  line-height: 1.6;
  color: var(--muted);
  margin: 0 0 20px;
}

.GiftCards-notifyForm-o1TD9 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 10px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.GiftCards-notifyInput-BXZJ3 {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 260px;
          flex: 1 1 260px;
  max-width: 340px;
  min-height: 48px;
  padding: 12px 16px;
  border: 1px solid var(--line);
  border-radius: 14px;
  font-size: 15px;
  background: #fff;
  color: var(--ink);
}

.GiftCards-notifyInput-BXZJ3:focus {
  outline: 2px solid var(--green);
  outline-offset: 1px;
  border-color: var(--green);
}

.GiftCards-notifyBtn-SgAzF {
  min-height: 48px;
  padding: 13px 26px;
  border: 0;
  border-radius: 14px;
  background: var(--red);
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, transform 0.16s;
  transition: background 0.16s, transform 0.16s, -webkit-transform 0.16s;
}

.GiftCards-notifyBtn-SgAzF:hover {
  background: var(--red-d);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

.GiftCards-notifyNote-vHy82 {
  margin: 18px 0 0;
  font-size: 13px;
  color: var(--muted);
}

.GiftCards-inlineLink-U5NII {
  color: var(--red);
  font-weight: 700;
  text-decoration: none;
}

.GiftCards-inlineLink-U5NII:hover {
  text-decoration: underline;
}

.GiftCards-srOnly-w6wk6 {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 760px) {
  .GiftCards-grid-TpFD_ {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .GiftCards-sec-nwBTl {
    padding: 44px 0;
  }
  .GiftCards-notifyCard-pCAz2 {
    padding: 28px 22px;
  }
}

@media (prefers-color-scheme: dark) {
  .GiftCards-page-Marvp {
    background: #14171a;
    color: #f3f4f6;
  }
  .GiftCards-alt-oJqwn {
    background: #1a1e22;
  }
  .GiftCards-h2-OxCId,
  .GiftCards-h2Left-fgxKE,
  .GiftCards-cardTitle-HNi4K {
    color: #f3f4f6;
  }
  .GiftCards-soonText-nukZ6,
  .GiftCards-cardText-BFGEr,
  .GiftCards-notifyText-dyxvg,
  .GiftCards-notifyNote-vHy82 {
    color: #9aa3ad;
  }
  .GiftCards-card-N3nW9 {
    background: #1d2125;
    border-color: #2c3137;
  }
  .GiftCards-cardIc-RTKMY,
  .GiftCards-soonBadge-N8Hwm {
    background: rgba(232, 35, 43, 0.14);
    border-color: rgba(232, 35, 43, 0.3);
  }
  .GiftCards-notifyCard-pCAz2 {
    background: rgba(22, 163, 74, 0.12);
    border-color: #2c3137;
  }
  .GiftCards-notifyInput-BXZJ3 {
    background: #1d2125;
    border-color: #2c3137;
    color: #f3f4f6;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/gift-cards/GiftCards.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;;AACvB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB;;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,YAAY;AACd;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA,gBAAgB;;AAChB;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,mBAAe;MAAf,mBAAe;UAAf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,6DAA6C;EAA7C,qDAA6C;EAA7C,6CAA6C;EAA7C,sEAA6C;AAC/C;;AACA;EACE,wBAAwB;EACxB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;;;IAGE,cAAc;EAChB;EACA;;;;IAIE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;;IAEE,mCAAmC;IACnC,oCAAoC;EACtC;EACA;IACE,mCAAmC;IACnC,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --green: #16a34a;\n  --green-d: #0f7a37;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.sec {\n  padding: 56px 0;\n}\n.alt {\n  background: #f7f8f9;\n}\n\n.h2 {\n  font-size: clamp(26px, 4vw, 36px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 28px;\n}\n.h2Left {\n  font-size: clamp(22px, 3.4vw, 30px);\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n\n/* Coming-soon banner */\n.soonSec {\n  padding: 36px 0 8px;\n  text-align: center;\n}\n.soonBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #fff0ef;\n  color: var(--red);\n  font-weight: 800;\n  font-size: 13px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  padding: 8px 16px;\n  border-radius: 999px;\n  border: 1px solid #f6c9cb;\n}\n.soonDot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--red);\n}\n.soonText {\n  max-width: 620px;\n  margin: 18px auto 0;\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--muted);\n}\n\n/* Pitch cards */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n.card {\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 28px 24px;\n  background: #fff;\n  text-align: center;\n}\n.cardIc {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  background: #fff0ef;\n  color: var(--red);\n  margin-bottom: 14px;\n}\n.cardIc svg {\n  width: 28px;\n  height: 28px;\n}\n.cardTitle {\n  font-size: 17px;\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n.cardText {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0;\n}\n\n/* Notify card */\n.notifyCard {\n  max-width: 620px;\n  margin: 0 auto;\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 34px 36px;\n  background: #e4f6f3;\n  text-align: center;\n}\n.notifyText {\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--muted);\n  margin: 0 0 20px;\n}\n.notifyForm {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.notifyInput {\n  flex: 1 1 260px;\n  max-width: 340px;\n  min-height: 48px;\n  padding: 12px 16px;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  font-size: 15px;\n  background: #fff;\n  color: var(--ink);\n}\n.notifyInput:focus {\n  outline: 2px solid var(--green);\n  outline-offset: 1px;\n  border-color: var(--green);\n}\n.notifyBtn {\n  min-height: 48px;\n  padding: 13px 26px;\n  border: 0;\n  border-radius: 14px;\n  background: var(--red);\n  color: #fff;\n  font-weight: 700;\n  font-size: 15px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.16s, transform 0.16s;\n}\n.notifyBtn:hover {\n  background: var(--red-d);\n  transform: translateY(-2px);\n}\n.notifyNote {\n  margin: 18px 0 0;\n  font-size: 13px;\n  color: var(--muted);\n}\n.inlineLink {\n  color: var(--red);\n  font-weight: 700;\n  text-decoration: none;\n}\n.inlineLink:hover {\n  text-decoration: underline;\n}\n\n.srOnly {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n@media (max-width: 760px) {\n  .grid {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 680px) {\n  .sec {\n    padding: 44px 0;\n  }\n  .notifyCard {\n    padding: 28px 22px;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .page {\n    background: #14171a;\n    color: #f3f4f6;\n  }\n  .alt {\n    background: #1a1e22;\n  }\n  .h2,\n  .h2Left,\n  .cardTitle {\n    color: #f3f4f6;\n  }\n  .soonText,\n  .cardText,\n  .notifyText,\n  .notifyNote {\n    color: #9aa3ad;\n  }\n  .card {\n    background: #1d2125;\n    border-color: #2c3137;\n  }\n  .cardIc,\n  .soonBadge {\n    background: rgba(232, 35, 43, 0.14);\n    border-color: rgba(232, 35, 43, 0.3);\n  }\n  .notifyCard {\n    background: rgba(22, 163, 74, 0.12);\n    border-color: #2c3137;\n  }\n  .notifyInput {\n    background: #1d2125;\n    border-color: #2c3137;\n    color: #f3f4f6;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `GiftCards-page-Marvp`,
	"wrap": `GiftCards-wrap-Mdtog`,
	"sec": `GiftCards-sec-nwBTl`,
	"alt": `GiftCards-alt-oJqwn`,
	"h2": `GiftCards-h2-OxCId`,
	"h2Left": `GiftCards-h2Left-fgxKE`,
	"soonSec": `GiftCards-soonSec-XaQLh`,
	"soonBadge": `GiftCards-soonBadge-N8Hwm`,
	"soonDot": `GiftCards-soonDot-M6c60`,
	"soonText": `GiftCards-soonText-nukZ6`,
	"grid": `GiftCards-grid-TpFD_`,
	"card": `GiftCards-card-N3nW9`,
	"cardIc": `GiftCards-cardIc-RTKMY`,
	"cardTitle": `GiftCards-cardTitle-HNi4K`,
	"cardText": `GiftCards-cardText-BFGEr`,
	"notifyCard": `GiftCards-notifyCard-pCAz2`,
	"notifyText": `GiftCards-notifyText-dyxvg`,
	"notifyForm": `GiftCards-notifyForm-o1TD9`,
	"notifyInput": `GiftCards-notifyInput-BXZJ3`,
	"notifyBtn": `GiftCards-notifyBtn-SgAzF`,
	"notifyNote": `GiftCards-notifyNote-vHy82`,
	"inlineLink": `GiftCards-inlineLink-U5NII`,
	"srOnly": `GiftCards-srOnly-w6wk6`
};
module.exports = ___CSS_LOADER_EXPORT___;
